/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Actuator_StateInputs */

/** @type {(inputs: Air_Handler_Unit_Actuator_StateInputs) => LocalizedString} */
const fr_air_handler_unit_actuator_state = () => /** @type {LocalizedString} */ ('air_handler_unit_actuator_state')

/**
* | output |
* | --- |
* | "State" |
*
* @param {Air_Handler_Unit_Actuator_StateInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_actuator_state = /** @type {((inputs?: Air_Handler_Unit_Actuator_StateInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Actuator_StateInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("State")
	return fr_air_handler_unit_actuator_state(inputs)
});